<!--  -->
<template>
  <div class="footer">
    <div class="cancel" @click="cancelOrder(orderDetail.orderNo)">取消订单</div>
    <div class="payment" @click="payOrder(orderDetail.orderNo)">立即支付</div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  props: {
    orderDetail: {
      type: Object,
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    // 取消订单
    cancelOrder(id) {
      this.$emit('showDiaLog', id);
    },
    // 立即支付
    payOrder(orderNumber) {
      if (this.$root.$data.isApp) {
        this.$sendToApp('payCenter', { orderNo: orderNumber }, false);
        return;
      }
      if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/myCourse/cashier/cashier?orderNo=${orderNumber}`,
        });
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: {
          orderNo: orderNumber,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 89px;
  padding: 0 36px;
  font-size: 25px;
  background: $bgWhite;
  .cancel {
    margin-right: 43px;
    color: $fontColorBlackLight;
    line-height: 36px;
  }
  .payment {
    @include commonBtn(187px, 63px, $theme_color, 32px, 25px, $bgWhite);
  }
}
</style>
